import script from "./labfooter.vue?vue&type=script&setup=true&lang=js"
export * from "./labfooter.vue?vue&type=script&setup=true&lang=js"

import "./labfooter.vue?vue&type=style&index=0&id=87e5631a&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e5631a"]])

export default __exports__